import React, { useRef } from "react";
import "./App.css";
import { Toaster } from "sonner";
import PlexusBackground from "./components/PlexusBackground";
import MagneticCursor from "./components/MagneticCursor";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import WhatIsProtos from "./components/WhatIsProtos";
import WhyItWorks from "./components/WhyItWorks";
import Formulation from "./components/Formulation";
import BeyondPerformance from "./components/BeyondPerformance";
import Benefits from "./components/Benefits";
import HowItStarted from "./components/HowItStarted";
import BetaInvite from "./components/BetaInvite";
import WhoParticipating from "./components/WhoParticipating";
import Participate from "./components/Participate";
import FinalCTA from "./components/FinalCTA";
import NotifyMe from "./components/NotifyMe";
import Footer from "./components/Footer";

function App() {
  const notifyRef = useRef(null);

  const scrollToNotify = () => {
    document.getElementById("notify")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App" data-testid="app-root">
      <PlexusBackground />
      <MagneticCursor />
      <Toaster theme="dark" position="bottom-right" />

      <Navbar onNotify={scrollToNotify} />
      <main>
        <Hero onNotify={scrollToNotify} />
        <Marquee />
        <WhatIsProtos />
        <WhyItWorks />
        <Formulation />
        <BeyondPerformance />
        <Benefits />
        <HowItStarted />
        <BetaInvite onNotify={scrollToNotify} />
        <WhoParticipating />
        <Participate onNotify={scrollToNotify} />
        <FinalCTA onNotify={scrollToNotify} />
        <NotifyMe formRef={notifyRef} />
      </main>
      <Footer />
    </div>
  );
}

export default App;
